module.exports = __webpack_public_path__ + "3acac99c7a4181a47bb061c53e07b5f5.pdf";